/**
 * Created by Bart Decorte
 * Date: 2019-06-05
 * Time: 19:58
 */
import Page from '../Page';
import 'flot';
import 'flot-spline';
import 'jquery.flot.tooltip';

export default class InsightsIndex extends Page {
  constructor() {
    super();
    this.weekdays = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    this.plotHourlyUsage();
    this.plotMinutelyUsage();
  }

  hourlyUsageData(data) {
    let counter = 0;
    data = data.map((point) => {
      (point = [counter, point.usage]), counter++;
      return point;
    });

    return data;
  }

  minutelyUsageLastHour() {
    let data = esign.info.minutelyUsageLastHour;

    let counter = 0;
    data = data.map((point) => {
      point = [counter, point.count];
      counter++;
      return point;
    });

    return data;
  }

  minutelyUsageTicks() {
    let data = esign.info.minutelyUsageLastHour;

    let counter = 0;
    let ticks = data.map((point) => {
      let minute = `${point.minute}`.padStart(2, '0');
      point = [counter, `${point.hour}:${minute}`];
      counter++;
      return point;
    });

    ticks = ticks.filter((value, index) => {
      return index % 5 == 0;
    });

    return ticks;
  }

  hourlyWeekdayXTicks() {
    let ticks = [];
    for (let i = 0; i < 7; i++) {
      ticks.push([i * 24 + 12, this.weekdays[i]]);
    }

    return ticks;
  }

  percentageTicks() {
    let ticks = [];
    for (let i = 0; i <= 100; i += 20) {
      ticks.push([i, `${i}%`]);
    }

    return ticks;
  }

  defaultPlotConfig() {
    return {
      series: {
        lines: {
          show: false,
          fill: true,
        },
        points: {
          radius: 0,
          show: true,
        },
        shadowSize: 2,
      },
      grid: {
        hoverable: true,
        clickable: true,

        borderWidth: 2,
        color: 'transparent',
      },
      colors: ['#1b3e85', '#00D97E', '#fd7e14'],
      xaxis: {},
      yaxis: {},
    };
  }

  splineConfig() {
    return {
      show: true,
      tension: 0.4,
      lineWidth: 1,
      fill: 0.4,
    };
  }

  plotHourlyUsage() {
    const config = this.defaultPlotConfig();
    config.xaxis.ticks = this.hourlyWeekdayXTicks();
    config.yaxis = {
      ticks: this.percentageTicks(),
      labelWidth: 30,
    };
    config.series.lines.show = false;
    config.series.splines = this.splineConfig();
    config.tooltip = {
      show: true,
      content: (label, xval, yval, flotItem) => {
        const weekdayNumber = Math.floor(xval / 24);
        const weekday = this.weekdays[weekdayNumber];
        const hour = xval - weekdayNumber * 24;
        return `${weekday} ${hour}h - ${hour + 1}h: ${yval}`;
      },
    };
    config.legend = {
      show: true,
      noColumns: 1,
      position: 'nw',
      labelFormatter: function(label, series) {
        return `<tspan dx="2em" dy="1.1em" style="font-size: 90%">${label}</tspan>`;
      },
    };

    $.plot(
      $('#js-usage-hourly'),
      [
        {
          label: 'All-time',
          data: this.hourlyUsageData(esign.info.hourlyUsage),
        },
        {
          label: 'Last 28 days',
          data: this.hourlyUsageData(esign.info.hourlyUsageLastFourWeeks),
        },
      ],
      config
    );
  }

  plotMinutelyUsage() {
    const config = this.defaultPlotConfig();
    config.xaxis.ticks = this.minutelyUsageTicks();
    config.series.bars = {
      show: true,
      align: 'center',
      lineWidth: 1,
    };
    config.tooltip = {
      show: true,
      content: (label, xval, yval, flotItem) => {
        let data = esign.info.minutelyUsageLastHour[xval];
        let minute = `${data.minute}`.padStart(2, '0');
        return `${data.hour}:${minute}: ${yval}`;
      },
    };

    $.plot(
      $('#js-usage-minutely-last-hour'),
      [{ label: 'Interactions', data: this.minutelyUsageLastHour() }],
      config
    );
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Insights/InsightsIndex.js